import { render, staticRenderFns } from "./PreviewTableFull.vue?vue&type=template&id=6bfe18f0&"
import script from "./PreviewTableFull.vue?vue&type=script&lang=js&"
export * from "./PreviewTableFull.vue?vue&type=script&lang=js&"
import style0 from "./PreviewTableFull.vue?vue&type=style&index=0&id=6bfe18f0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports